import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Handles Google's redirect back to /auth/google/callback?code=...&state=...
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const err = params.get("error");

    if (err) { setError(err); return; }
    if (!code || !state) { navigate("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google", { code, state });
        if (data.session_token) setToken(data.session_token);
        setUser(data);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard");
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFCFC]" data-testid="google-callback">
      {error ? (
        <div className="text-center">
          <div className="label-eyebrow text-[#FF3B30]">// SIGN-IN FAILED</div>
          <div className="font-mono text-sm mt-2 max-w-md text-neutral-700">{error}</div>
          <button onClick={() => navigate("/login")} className="mt-6 px-4 py-2 border border-neutral-900 hover:bg-neutral-900 hover:text-white text-sm font-semibold">
            Back to login
          </button>
        </div>
      ) : (
        <div className="label-eyebrow text-neutral-600">Signing you in…</div>
      )}
    </div>
  );
}
